import { render, staticRenderFns } from "./AdminNewsView.vue?vue&type=template&id=95f41ef6&scoped=true"
import script from "./AdminNewsView.vue?vue&type=script&lang=js"
export * from "./AdminNewsView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95f41ef6",
  null
  
)

export default component.exports